import { SellerLoginForm } from "../../components/seller/SellerLoginForm";

import React from "react";
import Grid from '@mui/material/Grid';


function SellerLogin() {

  return (
    <div>
      <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center sm:tw-ml-20 tw-text-left">

        <Grid container direction="row" alignItems="center" justifyContent="" >

          <Grid container>
            <Grid item xs={12} sm={12}>
              <span className="tw-p-10 tw-text-3xl"><p>Seller Login</p></span>
            </Grid>
          </Grid>

          <SellerLoginForm />

        </Grid>

      </div>
    </div>
  );

}


export { SellerLogin };
